import { FC, useEffect, useState } from "react";
import { Button, StepProps, Steps, message } from "antd";

interface CBStepsTypes {
  steps: Array<StepProps & { content: React.ReactNode }>;
  type?: "inline" | "navigation" | "default";
  size?: "small" | "default";
  direction?: "vertical" | "horizontal";
  status?: "wait" | "process" | "finish" | "error" | undefined;
  clickable?: boolean;
  navigation?: boolean;
  navigationPosition?: "start" | "center" | "end";
  stepPosition?: number;
}

const CBStepper: FC<CBStepsTypes> = ({
  steps,
  type = "default",
  size = "default",
  direction = "horizontal",
  status = undefined,
  clickable = false,
  navigation = false,
  navigationPosition = "start",
  stepPosition = 0,
}) => {
  const [current, setCurrent] = useState(stepPosition);
  const onChange = (value: number) => {
    if (clickable) setCurrent(value);
  };

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  useEffect(() => {
    setCurrent(stepPosition);
  }, [stepPosition]);

  return (
    <div className="CBStepper">
      <Steps
        status={status}
        type={type}
        size={size}
        direction={direction}
        current={current}
        onChange={onChange}
        items={steps}
      />
      <div>{steps[current].content}</div>
      {navigation && (
        <div
          style={{ marginTop: 25 }}
          className={`flex justify-${navigationPosition}`}
        >
          {current < steps.length - 1 && (
            <Button type="primary" onClick={() => next()}>
              Next
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button
              type="primary"
              onClick={() => message.success("Processing complete!")}
            >
              Done
            </Button>
          )}
          {current > 0 && (
            <Button style={{ margin: "0 15px" }} onClick={() => prev()}>
              Previous
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default CBStepper;
